import { Component, OnInit, ViewChild } from '@angular/core';
import { Listing } from 'src/app/shared/models/listing.model';
import { Languages, Service } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { GridViewComponent } from 'src/app/shared/components/grid-view/grid-view.component';
import { ReportsService } from 'src/app/shared/services/reports.service';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/shared/services/app.config';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/front-user/shared/models/user.model';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
//import { forEach } from '@angular/router/src/utils/collection';
//import { elementStart } from '@angular/core/src/render3';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { Country } from 'src/app/front-user/shared/models/country.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { Port } from 'src/app/front-user/shared/models/port.model';
import { VesselType } from '../../../../front-user/shared/models/vesselType.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { MyRequestsService } from 'src/app/shared/services/my-Requests.service';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';
import { ETenderAdminTypes } from 'src/app/shared/models/e-tender.model';
import { EtenderService } from 'src/app/shared/services/etender.service';
//import { escapeRegExp } from '@angular/compiler/src/util';

@Component({
  selector: 'app-long-haul-report',
  templateUrl: './long-haul-report.component.html',
  styleUrls: ['./long-haul-report.component.css']
})

export class LongHaulReportComponent implements OnInit {
  //#region Properties & Variables
  showAutoCompleteMinLengthMessage: Boolean;
  private collection: Listing;
  private itemsMenu: MenuItem[] = [];
  public sailDirections: SailDirection[] = [];
  lang: string;
  pageSize = 15;
  userName: string = "";
  requestNumber: string = "";
  isAdmin: Boolean;
  private isLHReportAdmin : boolean = false;
  creationDateFromFormatted: string = "";
  creationDateToFormatted: string = "";
  sailingDateFormatted: string = "";
  CancelationDateFromFormatted: string = "";
  CancelationDateToFormatted: string = "";
  formulatedDecisionDateFrom: string = "";
  formulatedDecisionDateTo: string = "";
  formulatedDecisionDateFromFormatted: string = "";
  formulatedDecisionDateToFormatted: string = "";
  sortBy: string = "";
  sortDir: string = "";
  userId: string = "";
  userGroups: number[] = [];

  creationDateFrom: string = ""
  creationDateTo: string = ""
  statusId: string = ""
  rebateFileNumber: string = ""
  imo: string = ""
  sailingDate: string = ""
  fromPortId: string = ""
  toPortId: string = ""
  fromCountryId: string = ""
  toCountryId: string = ""
  rebatePercentageFrom: string = ""
  rebatePercentageTo: string = ""

  shipTypeId: string = ""
  shipName: string = ""
  isPassed: Boolean = null;
  isrefunded: Boolean = null;
  isCancelled: Boolean = null;
  cancelationDateFrom: string = ""
  cancelationDateTo: string = ""
  directionId: string = "";
  exportngParametersUrl: string = "";

  ebookingReportLookups: EbookingReportLookups;
  public currentUser: User = new User();
  InvalidDateMessage: string;
  hideExportButton: Boolean
  isAutoCompleteLoading: Boolean
  agentsNamesList = [];
  agentNameNotFoundMessage: string;
  autoCompleteMinQueryLength: number = 3;
  AgentsNamesTextBoxPlaceHolder: string;
  showFromDateGreaterThanTodayDateMessage: Boolean
  showFromDateGreaterThanToDateMessage: Boolean
  showCancelationFromDateGreaterThanCancelationToDateMessage: Boolean
  showFormulatedDecisionDateFromGreaterThanTodayDateMessage : Boolean
  showFormulatedDecisionFromDateGreaterThanFormulatedDecisionDateToMessage: Boolean

  showCancelledRequestsFiltersDiv: Boolean = false;
  public countries: GenericLookup[] = [];
  public ports: Port[] = [];
  public vesselTypes: GenericLookup[] = [];
  private lastPortsOrigin: Port[] = [];
  private firstPortsDestination: Port[] = [];
  public statusesList: [] = [];
  responseObj: ResponseObject;
  isErrorMessage: Boolean = false;

  @ViewChild('LongHaulReport',{static: false}) gridView: GridViewComponent;
  HasMenu: boolean = true;
  //#endregion

  constructor(private etenderSrv: EtenderService,private route: Router,private myReportsService: ReportsService, private global: GlobalServices, private myRequestsService: MyRequestsService, private agentService: AgentService, private translate: TranslateService, private authenticationService: AuthenticationService, private router: Router, private localeService: BsLocaleService, private lookupService: LookupService, public datepipe: DatePipe) {
    this.lang = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
    this.currentUser = this.authenticationService.currentUserValue;
    this.etenderSrv.GetUserGroups(this.currentUser.Email).subscribe(
      data => {
        this.userGroups = data.Data;
        if(this.userGroups != null)
        {
          if (this.userGroups.filter(ug => ug == ETenderAdminTypes.SCAServices_MeasurementCommittee ||
            ug == ETenderAdminTypes.SCAServices_EconomicCommittee ||
            ug == ETenderAdminTypes.SCAServices_MeasurementSuez ||
            ug == ETenderAdminTypes.SCAServices_MeasurementPortSaid||
            ug == ETenderAdminTypes.SCAServices_LHManagementandReportsOnly||
            ug == ETenderAdminTypes.SCAServices_LongHaulFormulatedDecision).length > 0) {
            this.isLHReportAdmin = true;
          }
        }

    if(!this.isLHReportAdmin)
      this.route.navigateByUrl('/workspace');
    },
    () => console.log('Something went wrong!!')
  );
  }


  myControl = new FormControl();
  options: string[] = ['One', 'Two', 'Three'];
  filteredOptions: Observable<string[]>;


  async ngOnInit() {

    this.InvalidDateMessage = await this.translate.get('SHARED.InvalidDate').toPromise();
    this.AgentsNamesTextBoxPlaceHolder = await this.translate.get('SHARED.REPORTS.AGENT_NAME_MIN_CHARS').toPromise();

    this.currentUser = this.authenticationService.currentUserValue;
    //this.currentUser = this.global.user;
    enGbLocale.invalidDate = this.InvalidDateMessage;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
    if (this.currentUser.IsAdmin) {
      this.isAdmin = true;
    }
    else {
      this.router.navigate(['/workspace']);
    }

    this.loadCountries();
    this.loadVesselTypes();
    this.loadSailDirections();
    this.loadLookups();
    this.loadSearchCriteria();
    this.loadLongHaulReport();
    this.lang = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
    this.agentNameNotFoundMessage = this.translate.instant('SHARED.NoItems');


  }

  loadVesselTypes(): void {
    this.lookupService.getVesselTypes().subscribe(
      data => this.vesselTypes = data.Data as VesselType[],
      () => console.log("Something went wrong!!"),

    );
  }

  loadSailDirections(): void {
    this.lookupService.getSailDirections().subscribe(
      data => this.sailDirections = data.Data as SailDirection[],
      () => console.log("Something went wrong!!"),
      () => console.log("Completed")
    );
  }
  loadAgentsDisplayNames(keyWord: string) {
    this.isAutoCompleteLoading = true;
    this.agentService.GetAgentsInfoByDisplayName(keyWord).subscribe(s => {
      this.agentsNamesList = s.Data;
      this.isAutoCompleteLoading = false;
    });
  }
  async CloseRequests() {

    this.removeAllValidationMessages()
    // if (this.isFromDateGreaterThanTodayDate()) {
    //   this.showFromDateGreaterThanTodayDateMessage = true;
    //   return;
    // }

    if (this.isCreationFromDateGreaterThanCreationToDate()) {
      this.showFromDateGreaterThanToDateMessage = true;
      return;
    }

    if (this.isCancelationFromDateGreaterThanCancelationToDate()) {
      this.showCancelationFromDateGreaterThanCancelationToDateMessage = true;

      return;
    }


    if (this.isFormulatedDecisionFromDateGreaterThanFormulatedDecisionToDate()) {
      this.showFormulatedDecisionFromDateGreaterThanFormulatedDecisionDateToMessage = true;
      return;
    }

    this.loadLongHaulCloseRequests();
  }
  loadLongHaulCloseRequests() {

    this.storeSearchCriteria();

    this.creationDateFrom = this.creationDateFrom == null ? "" : this.creationDateFrom;
    this.creationDateTo = this.creationDateTo == null ? "" : this.creationDateTo;
    if (this.creationDateFrom.toString() != this.InvalidDateMessage && this.creationDateTo.toString() != this.InvalidDateMessage) {
      this.global.isLoaderEnabled = true;
      this.creationDateFromFormatted = this.creationDateFrom == "" ? "" : this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
      this.creationDateToFormatted = this.creationDateTo == "" ? "" : this.datepipe.transform(this.creationDateTo, 'MM/dd/yyyy');
      this.sailingDateFormatted = this.sailingDate == "" ? "" : this.datepipe.transform(this.sailingDate, 'MM/dd/yyyy');
      this.CancelationDateFromFormatted = this.cancelationDateFrom == "" ? "" : this.datepipe.transform(this.cancelationDateFrom, 'MM/dd/yyyy');
      this.CancelationDateToFormatted = this.cancelationDateTo == "" ? "" : this.datepipe.transform(this.cancelationDateTo, 'MM/dd/yyyy');
      this.formulatedDecisionDateFromFormatted = this.formulatedDecisionDateFrom == "" ? "" : this.datepipe.transform(this.formulatedDecisionDateFrom, 'MM/dd/yyyy');
      this.formulatedDecisionDateToFormatted = this.formulatedDecisionDateTo == "" ? "" : this.datepipe.transform(this.formulatedDecisionDateTo, 'MM/dd/yyyy');
      this.createExportingParametersUrl();
      this.myReportsService.UpdateLongHaulRequestsToClosed(0,
        this.pageSize,
        this.sortBy,
        this.sortDir,
        this.userId,
        encodeURIComponent(this.userName),
        this.requestNumber,
        this.creationDateFromFormatted,
        this.creationDateToFormatted,
        this.statusId,
        this.rebateFileNumber,
        this.imo,
        this.sailingDateFormatted,
        this.fromCountryId,
        this.toCountryId,
        this.fromPortId,
        this.toPortId,
        this.rebatePercentageFrom,
        this.rebatePercentageTo,
        this.shipTypeId,
        encodeURIComponent( this.shipName),
        this.isPassed,
        this.isrefunded,
        this.isCancelled,
        this.CancelationDateFromFormatted,
        this.CancelationDateToFormatted,
        this.directionId,
        this.formulatedDecisionDateFromFormatted,
        this.formulatedDecisionDateToFormatted
      ).subscribe(
        s => {

          this.responseObj = s;
          if (!this.responseObj.Success) {
            this.isErrorMessage = true;
          }

          this.collection = s.Data;
          this.hideExportButton = s.Data.TotalNumber > 0 ? false : true;
        },
        () => console.log("Something went wrong!!"),
        () => this.loadCollectionCompleted());
    }
  }
  getLongHaulReportData() {

    this.removeAllValidationMessages()
    // if (this.isFromDateGreaterThanTodayDate()) {
    //   this.showFromDateGreaterThanTodayDateMessage = true;
    //   return;
    // }

    if (this.isCreationFromDateGreaterThanCreationToDate()) {
      this.showFromDateGreaterThanToDateMessage = true;
      return;
    }

    if (this.isCancelationFromDateGreaterThanCancelationToDate()) {
      this.showCancelationFromDateGreaterThanCancelationToDateMessage = true;

      return;
    }


    if (this.isFormulatedDecisionFromDateGreaterThanFormulatedDecisionToDate()) {
      this.showFormulatedDecisionFromDateGreaterThanFormulatedDecisionDateToMessage = true;
      return;
    }

    this.loadLongHaulReport();
  }

  loadLongHaulReport() {

    this.storeSearchCriteria();

    this.creationDateFrom = this.creationDateFrom == null ? "" : this.creationDateFrom;
    this.creationDateTo = this.creationDateTo == null ? "" : this.creationDateTo;
    if (this.creationDateFrom.toString() != this.InvalidDateMessage && this.creationDateTo.toString() != this.InvalidDateMessage) {
      this.global.isLoaderEnabled = true;
      this.creationDateFromFormatted = this.creationDateFrom == "" ? "" : this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
      this.creationDateToFormatted = this.creationDateTo == "" ? "" : this.datepipe.transform(this.creationDateTo, 'MM/dd/yyyy');
      this.sailingDateFormatted = this.sailingDate == "" ? "" : this.datepipe.transform(this.sailingDate, 'MM/dd/yyyy');
      this.CancelationDateFromFormatted = this.cancelationDateFrom == "" ? "" : this.datepipe.transform(this.cancelationDateFrom, 'MM/dd/yyyy');
      this.CancelationDateToFormatted = this.cancelationDateTo == "" ? "" : this.datepipe.transform(this.cancelationDateTo, 'MM/dd/yyyy');
      this.formulatedDecisionDateFromFormatted = this.formulatedDecisionDateFrom == "" ? "" : this.datepipe.transform(this.formulatedDecisionDateFrom, 'MM/dd/yyyy');
      this.formulatedDecisionDateToFormatted = this.formulatedDecisionDateTo == "" ? "" : this.datepipe.transform(this.formulatedDecisionDateTo, 'MM/dd/yyyy');
      this.createExportingParametersUrl();
      this.myReportsService.getLongHaulReport(0,
        this.pageSize,
        this.sortBy,
        this.sortDir,
        this.userId,
        encodeURIComponent(this.userName),
        this.requestNumber,
        this.creationDateFromFormatted,
        this.creationDateToFormatted,
        this.statusId,
        this.rebateFileNumber,
        this.imo,
        this.sailingDateFormatted,
        this.fromCountryId,
        this.toCountryId,
        this.fromPortId,
        this.toPortId,
        this.rebatePercentageFrom,
        this.rebatePercentageTo,
        this.shipTypeId,
        encodeURIComponent( this.shipName),
        this.isPassed,
        this.isrefunded,
        this.isCancelled,
        this.CancelationDateFromFormatted,
        this.CancelationDateToFormatted,
        this.directionId,
        this.formulatedDecisionDateFromFormatted,
        this.formulatedDecisionDateToFormatted
      ).subscribe(
        s => {

          this.responseObj = s;
          if (!this.responseObj.Success) {
            this.isErrorMessage = true;
          }

          this.collection = s.Data;
          this.hideExportButton = s.Data.TotalNumber > 0 ? false : true;
        },
        () => console.log("Something went wrong!!"),
        () => this.loadCollectionCompleted());
    }
  }

  loadCollectionCompleted() {
    this.loadItemsMenu();
    var url = "Report/GetLongHaulReport?pageIndex={PAGEINDEX}"
      + "&pageSize=" + this.pageSize
      + "&sortBy=" + this.sortBy
      + "&sortDir=" + this.sortDir
      + '&language=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + "&userId=" + this.userId
      + "&userName=" +encodeURIComponent(this.userName)
      + "&requestNumber=" + this.requestNumber
      + "&submissionDateFrom=" + this.creationDateFromFormatted
      + "&submissionDateTo=" + this.creationDateToFormatted
      + "&statusId=" + this.statusId
      + "&rebateFileNumber=" + this.rebateFileNumber
      + "&imo=" + this.imo
      + "&sailingDate=" + this.sailingDateFormatted
      + "&fromCountryId=" + this.fromCountryId
      + "&toCountryId=" + this.toCountryId
      + "&fromPortId=" + this.fromPortId
      + "&toPortId=" + this.toPortId
      + "&rebatePercentageFrom=" + this.rebatePercentageFrom
      + "&rebatePercentageTo=" + this.rebatePercentageTo
      + "&shipTypeId=" + this.shipTypeId
      + "&shipName=" +encodeURIComponent( this.shipName)
      + "&isPassed=" + this.isPassed
      + "&isrefunded=" + this.isrefunded
      + "&isCancelled=" + this.isCancelled
      + "&cancelationDateFrom=" + this.CancelationDateFromFormatted
      + "&cancelationDateTo=" + this.CancelationDateToFormatted
      + "&directionId=" + this.directionId
      + "&formulatedDecisionDateFrom=" + this.formulatedDecisionDateFromFormatted
      + "&formulatedDecisionDateTo=" + this.formulatedDecisionDateToFormatted;
    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      url, "SHARED.REPORTS.LONGHAUL_OBJECT", this.itemsMenu, "", "", "");
    //Disable Loader
    this.global.isLoaderEnabled = false;
  }




  loadCountries(): void {
    this.lookupService.getCountries().subscribe(
      data => this.countries = data.Data as Country[],
      () => console.log("Something went wrong!!"),
      () => this.loadCountriesCompleted()
    );
  }

  loadCountriesCompleted(): void {
    this.loadPorts();
  }
  loadPorts(): void {
    //this.lookupService.getPorts().subscribe((data: ResponseObject) => {
    //  this.ports = data.Data as Port[];
    //});
    this.lookupService.getPorts().subscribe(
      data => this.ports = data.Data as Port[],
      () => console.log("Something went wrong!!"),
      // () => this.loadPortsCompleted()
    );
  }

  loadPortsCompleted(): void {
    this.lastPortsOrigin = this.firstPortsDestination = this.ports.filter((item) => item.CountryId == this.countries[0].Id);

  }
  onLastCountrySelect(countryId: number): void {
    this.lastPortsOrigin = this.ports.filter((item) => item.CountryId == countryId);
  }
  onFirstCountrySelect(countryId: number): void {
    this.firstPortsDestination = this.ports.filter((item) => item.CountryId == countryId);
  }

  onChangeCancelledRequestsCheckbox(event) {

    var isChecked = event.target.checked;
    if (isChecked) {
      this.showCancelledRequestsFiltersDiv = true;
    }
    else {
      this.showCancelledRequestsFiltersDiv = false;
      this.cancelationDateFrom = "";
      this.cancelationDateTo = "";
      this.CancelationDateFromFormatted = "";
      this.CancelationDateToFormatted = "";

    }
  }

  resetFilters() {
    this.creationDateFrom = "";
    this.creationDateTo = "";
    this.creationDateFromFormatted = "";
    this.creationDateToFormatted = "";
    this.cancelationDateFrom = "";
    this.cancelationDateTo = "";
    this.CancelationDateFromFormatted = "";
    this.CancelationDateToFormatted = "";
    this.creationDateToFormatted = "";

    this.formulatedDecisionDateFrom = "";
    this.formulatedDecisionDateFromFormatted = "";
    this.formulatedDecisionDateTo = "";
    this.formulatedDecisionDateToFormatted = "";

    this.statusId = "";
    this.userName = "";
    this.requestNumber = "";
    this.fromCountryId= "";
    this.toCountryId= "";
    this.fromPortId = "";
    this.toPortId = "";
    this.rebateFileNumber = "";
    this.sailingDate = "";
    this.sailingDateFormatted = "";
    this.rebatePercentageFrom = null;
    this.rebatePercentageTo = null;
    this.directionId = "";
    this.imo = "";
    this.shipName = "";
    this.shipTypeId = "";
    this.isrefunded = null;
    this.isPassed = null;
    this.isCancelled = null;
    this.hideExportButton = false;
    this.showFromDateGreaterThanTodayDateMessage = false;
    this.showFromDateGreaterThanToDateMessage = false;
    this.showCancelationFromDateGreaterThanCancelationToDateMessage = false;
    this.showFormulatedDecisionDateFromGreaterThanTodayDateMessage = false;
    this.showFormulatedDecisionFromDateGreaterThanFormulatedDecisionDateToMessage= false;
    this.showCancelledRequestsFiltersDiv = false;
    this.loadLongHaulReport();
  }

  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[0].TitleAr = "التفاصيل";
    this.itemsMenu[1] = new MenuItem();
    this.itemsMenu[1].Title = "Request History";
    this.itemsMenu[1].TitleAr = "تاريخ الطلب";
    if (this.currentUser.IsAdmin) {
      this.itemsMenu[2] = new MenuItem();
      this.itemsMenu[2].Title = "Workflow Status";
      this.itemsMenu[2].TitleAr = "حالة مسار العمل";
      this.itemsMenu[3] = new MenuItem();
      this.itemsMenu[3].Title = "Release Form";
      this.itemsMenu[3].TitleAr = "Release Form";
    }
  }

  loadLookups() {
    this.myReportsService.getEbookingReportLookups().subscribe(
      data => this.ebookingReportLookups = data.Data,
      () => console.log("Something went wrong!!"),
      () => console.log("Completed"));



    this.myRequestsService.getMyRequestsStatusesLookups(Service.LongHaul).subscribe(
      response => this.statusesList = response.Data.Statuses,
      () => console.log("Something went wrong!!"),
      () => console.log("Completed"),

    );

  }


  async EconomicExport() {

    let response = await this.translate.get('SHARED.REPORTS.LONGHAUL_OBJECT').toPromise();

    console.log(response);
    let longHaulObjectAsString = JSON.stringify(response)


    let ExportExcellUrl = AppConfig.settings.apiServer.apiUrl +
      "Report/ExportLongHaulReportExcel?longHaulExportingObject=" + longHaulObjectAsString + this.exportngParametersUrl;
    window.open(ExportExcellUrl, '_self');



  }

  async MeasurementExport() {

    let response = await this.translate.get('SHARED.REPORTS.LONGHAUL_OBJECT_Measurement').toPromise();
    let longHaulObjectAsString = JSON.stringify(response)
    let ExportExcellUrl = AppConfig.settings.apiServer.apiUrl +
      "Report/ExportMeasurementLongHaulReportExcel?longHaulExportingObject=" + longHaulObjectAsString + this.exportngParametersUrl;
    window.open(ExportExcellUrl, '_self');
  }

  createExportingParametersUrl() {
    this.exportngParametersUrl = "&sortBy=" + this.sortBy
      + "&sortDir=" + this.sortDir
      + '&language=' + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En")
      + "&userId=" + this.userId
      + "&userName=" + encodeURIComponent(this.userName)
      + "&requestNumber=" + this.requestNumber
      + "&submissionDateFrom=" + this.creationDateFromFormatted
      + "&submissionDateTo=" + this.creationDateToFormatted
      + "&statusId=" + this.statusId
      + "&rebateFileNumber=" + this.rebateFileNumber
      + "&imo=" + this.imo
      + "&sailingDate=" + this.sailingDateFormatted
      + "&fromCountryId=" + this.fromCountryId
      + "&toCountryId=" + this.toCountryId
      + "&fromPortId=" + this.fromPortId
      + "&toPortId=" + this.toPortId
      + "&rebatePercentageFrom=" + this.rebatePercentageFrom
      + "&rebatePercentageTo=" + this.rebatePercentageTo
      + "&shipTypeId=" + this.shipTypeId
      + "&shipName=" +encodeURIComponent( this.shipName)
      + "&isPassed=" + this.isPassed
      + "&isrefunded=" + this.isrefunded
      + "&isCancelled=" + this.isCancelled
      + "&cancelationDateFrom=" + this.CancelationDateFromFormatted
      + "&cancelationDateTo=" + this.CancelationDateToFormatted
      + "&directionId=" + this.directionId
      + "&formulatedDecisionDateFrom=" + this.formulatedDecisionDateFromFormatted
      + "&formulatedDecisionDateTo=" + this.formulatedDecisionDateToFormatted;

  }
  keyword = 'DisplayName';
  selectAgentNameEvent(item) {

    console.log(item);
    this.userName = item.DisplayName;
  }






  onAgentsNamesSearchChange(val: string) {

    this.loadAgentsDisplayNames(val);
    //     if(val.length<2)
    //     {
    // this.showAutoCompleteMinLengthMessage = true;
    // alert(val.length);


    //     }
    //     else
    //     {
    //       this.showAutoCompleteMinLengthMessage = false;
    //     this.loadAgentsDisplayNames(val);
    //     }
  }

  onFocused(e) {

    // do something when input is focused
  }


  storeSearchCriteria() {
    this.global.longHaulReportSearchCriteria = [];
    this.global.longHaulReportSearchCriteria.push({
      creationDateFrom: this.creationDateFrom,
      creationDateTo: this.creationDateTo,
      requestNumber: this.requestNumber,
      statusId: this.statusId,
      userName: this.userName,
      rebateFileNumber: this.rebateFileNumber,
      imo: this.imo,
      sailingDate: this.sailingDate,
      rebatePercentageFrom: this.rebatePercentageFrom,
      rebatePercentageTo: this.rebatePercentageTo,
      shipTypeId: this.shipTypeId,
      shipName: this.shipName,
      fromCountryId: this.fromCountryId,
      fromPortId: this.fromPortId,
      toCountryId: this.toCountryId,
      toPortId: this.toPortId,
      isrefunded: this.isrefunded,
      isPassed: this.isPassed,
      isCancelled: this.isCancelled,
      cancelationDateFrom: this.cancelationDateFrom,
      cancelationDateTo: this.cancelationDateTo,
      directionId: this.directionId,
      formulatedDecisionDateFrom: this.formulatedDecisionDateFrom,
      formulatedDecisionDateTo: this.formulatedDecisionDateTo
    });




  }

  loadSearchCriteria() {
    if (this.global.longHaulReportSearchCriteria.length > 0) {

      this.creationDateFrom = this.global.longHaulReportSearchCriteria[0].creationDateFrom;
      this.creationDateTo = this.global.longHaulReportSearchCriteria[0].creationDateTo;
      this.requestNumber = this.global.longHaulReportSearchCriteria[0].requestNumber;
      this.statusId = this.global.longHaulReportSearchCriteria[0].statusId;
      this.userName = this.global.longHaulReportSearchCriteria[0].userName;
      this.rebateFileNumber = this.global.longHaulReportSearchCriteria[0].rebateFileNumber;
      this.imo = this.global.longHaulReportSearchCriteria[0].imo;
      this.sailingDate = this.global.longHaulReportSearchCriteria[0].sailingDate;
      this.rebatePercentageFrom = this.global.longHaulReportSearchCriteria[0].rebatePercentageFrom;
      this.rebatePercentageTo = this.global.longHaulReportSearchCriteria[0].rebatePercentageTo;
      this.shipTypeId = this.global.longHaulReportSearchCriteria[0].shipTypeId;
      this.shipName = this.global.longHaulReportSearchCriteria[0].shipName;
      this.fromCountryId = this.global.longHaulReportSearchCriteria[0].fromCountryId;
      this.fromPortId = this.global.longHaulReportSearchCriteria[0].fromPortId;
      this.toCountryId = this.global.longHaulReportSearchCriteria[0].toCountryId;
      this.toPortId = this.global.longHaulReportSearchCriteria[0].toPortId;
      this.isrefunded = this.global.longHaulReportSearchCriteria[0].isrefunded;
      this.isPassed = this.global.longHaulReportSearchCriteria[0].isPassed;
      this.isCancelled = this.global.longHaulReportSearchCriteria[0].isCancelled;
      this.cancelationDateFrom = this.global.longHaulReportSearchCriteria[0].cancelationDateFrom;
      this.cancelationDateTo = this.global.longHaulReportSearchCriteria[0].cancelationDateTo;
      this.directionId = this.global.longHaulReportSearchCriteria[0].directionId;
      this.formulatedDecisionDateFrom = this.global.longHaulReportSearchCriteria[0].formulatedDecisionDateFrom;
      this.formulatedDecisionDateTo = this.global.longHaulReportSearchCriteria[0].formulatedDecisionDateTo;
      this.global.longHaulReportSearchCriteria = [];

    }
  }

  isCreationFromDateGreaterThanCreationToDate(): Boolean {
    var isFromDateGreaterThanToDate = false;
    if (this.creationDateTo) {
      isFromDateGreaterThanToDate = this.creationDateFrom > this.creationDateTo;
    }
    return isFromDateGreaterThanToDate;
  }

  isCancelationFromDateGreaterThanCancelationToDate(): Boolean {
    this.cancelationDateFrom

    var isCancelationFromDateGreaterThanCancelationToDate = false;
    if (this.cancelationDateTo) {
      isCancelationFromDateGreaterThanCancelationToDate = this.cancelationDateFrom > this.cancelationDateTo;
    }
    return isCancelationFromDateGreaterThanCancelationToDate;
  }




  isFormulatedDecisionFromDateGreaterThanFormulatedDecisionToDate(): Boolean {

    var isFormulatedDecisionFromDateGreaterThanFormulatedDecisionToDate = false;
    if (this.formulatedDecisionDateTo) {
      isFormulatedDecisionFromDateGreaterThanFormulatedDecisionToDate = this.formulatedDecisionDateFrom > this.formulatedDecisionDateTo;
    }
    return isFormulatedDecisionFromDateGreaterThanFormulatedDecisionToDate;
  }

  isFromDateGreaterThanTodayDate(): Boolean {

    var isFromDateGreaterThanTodayDate = false;
    var today = new Date();
    var todayDate = this.datepipe.transform(today, 'MM/dd/yyyy');
    var selectedCreationDateFrom = this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
    isFromDateGreaterThanTodayDate = selectedCreationDateFrom > todayDate;
    return isFromDateGreaterThanTodayDate;
  }
  removeAllValidationMessages() {
    this.showFromDateGreaterThanTodayDateMessage = false;
    this.showFromDateGreaterThanToDateMessage = false;
    this.showCancelationFromDateGreaterThanCancelationToDateMessage = false;
    this.showFormulatedDecisionDateFromGreaterThanTodayDateMessage = false;
    this.showCancelationFromDateGreaterThanCancelationToDateMessage = false;
    this.showFormulatedDecisionFromDateGreaterThanFormulatedDecisionDateToMessage = false;
  }

  numericOnly(event:any): boolean {
    let pattern = /^\d+$/;
    let entredValue;
    let result;
    let clipboard = (event.originalEvent || event).clipboardData;
    if (clipboard === undefined || clipboard === null) {
      entredValue = event.key;
    }
    else {

      entredValue = clipboard.getData('text');
    }
    result = pattern.test(entredValue);
    return result;
  }
}


export class MenuItem {
  Title: string;
  TitleAr: string;
};

export class EbookingReportLookups {
  public Services = [];
  public Statuses = [];
};
